export const SplitType = {
    AUTO_SPLIT: 'autoSplit',
    MANUAL_SPLIT: 'manualSplit',
    NO_SPLIT: 'noSplit',
};
